// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"7f0c5a43","424":"aa9276dc","495":"7279f84e","568":"ec4fcde2","591":"131a632d","630":"00b9fc93","642":"dd5ecb6a","771":"08c48fea"}[chunkId] + ".chunk.js";
};